import { SUPPLIERS } from '../types/index';

const initialState = [];

export default function(state = initialState, action) {

    switch(action.type) {

        case SUPPLIERS: 

            return action.payload;

        default:

            return state;

    }

};